<app-common-screen #commonComponent></app-common-screen>
